import { UserProperties, RoleList } from '../screens/user/types/user.type';
import { IHttpResponse } from './pagination';
import axios from 'axios';
import { capitalizeFirstLetter } from '@qlibs/react-components';

export const APP_AUTH_TOKEN = process.env.REACT_APP_ID + '_auth';
const CMS_DEVICE_ID = process.env.REACT_APP_ID + '_device_id';

export function getCmsDeviceId() {
  const currentDeviceId = localStorage.getItem(CMS_DEVICE_ID);
  if (currentDeviceId) {
    return currentDeviceId;
  }

  const deviceId =
    typeof globalThis.crypto?.randomUUID === 'function'
      ? globalThis.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

  localStorage.setItem(CMS_DEVICE_ID, deviceId);
  return deviceId;
}

export function saveToken(token: string) {
  return localStorage.setItem(APP_AUTH_TOKEN, token);
}

export function getToken() {
  return localStorage.getItem(APP_AUTH_TOKEN);
}

export function removeToken() {
  return localStorage.removeItem(APP_AUTH_TOKEN);
}

export function showRoleName(role: string) {
  if (RoleList[role]) {
    return RoleList[role];
  } else {
    return role
      .split('_')
      .map((item) => capitalizeFirstLetter(item))
      .join(' ');
  }
}

export const getLoginData = async (token?: string) => {
  const headers = {
    Authorization: 'Bearer ' + (token ? token : getToken()),
  };
  const resultUser = await axios.get<IHttpResponse<UserProperties>>(
    process.env.REACT_APP_BASE_URL + '/users/me',
    { headers }
  );

  return {
    user: resultUser.data.payload,
    role: resultUser.data.payload.userType,
  };
};
